import { useQuery } from '@tanstack/react-query';
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { client } from '../../lib/amplify-client';

export interface ShippingAddressEntry {
  id: string;
  label?: string | null;
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}

export interface PaymentMethodEntry {
  id: string;
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
  billing_address?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  } | null;
}

export interface Profile {
  payment_method_last4: string | null;
  payment_method_brand: string | null;
  last_viewed_card_id: string | null;
  last_viewed_card_name: string | null;
  last_viewed_card_points_cost: number | null;
  addresses: ShippingAddressEntry[];
  payment_methods: PaymentMethodEntry[];
  default_address_id: string | null;
  default_payment_method_id: string | null;
  stripe_customer_id: string | null;
  profile_onboarded: boolean;
  marketing_state: { optin_general: boolean; optin_drops: boolean } | null;
}

async function fetchProfile(): Promise<Profile | null> {
  const result: { data?: unknown; errors?: { message: string }[] } =
    await (client.queries as any).getProfile({
      authMode: 'userPool',
    });
  /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
  if (result.errors && result.errors.length > 0) {
    throw new Error(
      `getProfile failed: ${result.errors.map((e) => e.message).join('; ')}`,
    );
  }
  return (result.data as Profile | null) ?? null;
}

export function useGetProfile(enabled: boolean) {
  return useQuery({
    queryKey: ['profile'] as const,
    queryFn: fetchProfile,
    enabled,
    staleTime: 60_000,
  });
}
